import React, { useEffect, useState, useContext, useRef } from "react";
import group from "../assets/img/about arrow.svg";
import group1 from "../assets/img/about arrow-2.svg";
import city1 from "../assets/img/city1.png";
import city2 from "../assets/img/city2.png";
import Founder from "../assets/img/Founder.png";
import badge from "../assets/img/badge.png";
import mission from "../assets/img/mission.png";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../pages/languagecontext";
import API from "../pages/Services/Baseservice";

import ClipLoader from "react-spinners/ClipLoader";
import icon from "../assets/img/flags.png";
import SEO from "./SEO";
const AboutUs = () => {
  const [aboutus, setAboutUs] = useState("");
  const [aboutuslist, setAboutUsList] = useState([]);
  const [aboutusvision, setAbouUsVision] = useState("");
  const [aaboutusValue, setAboutUsValue] = useState("");
  const [founder, setFounder] = useState("");
  const [foundermetrics, setFounderMetrics] = useState("");
  const [ourstory, setourStory] = useState("");
  const [ourstorysection, setOurStorySection] = useState("");
  const [ourmission, setOurMission] = useState("");
  const [ourmissionsection, setOurMissionSection] = useState("");
  const [loading, setLoading] = useState(true);

  const { selectedLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  const home = () => {
    navigate("/");
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const imageRef = useRef(null);
  const contentRef = useRef(null);
  const parentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 992) {
        if (imageRef.current) {
          imageRef.current.style.position = "static";
          imageRef.current.style.top = "auto";
          imageRef.current.style.width = "100%";
        }
        return;
      }

      if (!imageRef.current || !contentRef.current || !parentRef.current)
        return;

      const image = imageRef.current;
      const content = contentRef.current;
      const parent = parentRef.current;
      const imageHeight = image.offsetHeight;
      const contentHeight = content.offsetHeight;
      const scrollTop = window.scrollY;
      const parentTop = parent.offsetTop;

      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 80;
      const offsetTop = headerHeight + 20;

      if (imageHeight >= contentHeight) {
        image.style.position = "static";
        image.style.top = "auto";
        return;
      }

      const scrollPosition = scrollTop + offsetTop;

      if (scrollPosition < parentTop) {
        image.style.position = "static";
        image.style.top = "auto";
        image.style.width = "100%";
      } else if (scrollPosition + imageHeight < parentTop + contentHeight) {
        image.style.position = "fixed";
        image.style.top = offsetTop + 50 + "px";
        image.style.width = image.parentElement.offsetWidth - 20 + "px";
      } else {
        image.style.position = "absolute";
        image.style.top = contentHeight - imageHeight + "px";
        image.style.width = "40%";
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [loading, founder]);

  useEffect(() => {
    aboutuspage();
  }, [selectedLanguage.id]);

  const aboutuspage = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webaboutus_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setAboutUsList(res.data.data);
        setAboutUs(res.data.data.about_us[0]);
        setAboutUsValue(res.data.data.aboutus_title[0]);
        setAbouUsVision(res.data.data.aboutus_title[1]);
        setFounder(res.data.data.founder[0]);
        setFounderMetrics(res.data.data.founder_metrics);
        setourStory(res.data.data.our_story[0]);
        setOurStorySection(res.data.data.our_story_sections);
        setOurMission(res.data.data.our_mission[0]);
        setOurMissionSection(res.data.data.our_mission_sections);
        setLoading(false);
      }
    });
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      <SEO
                title="Canadian immigration services | Immigration consultant Canada"
                description="ASRA Migration provides trusted Canadian immigration services, guiding students, workers, and families with transparent advice and end-to-end support."
                canonical="https://asraimmigration.ca/aboutus"
            />
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div className="container px-3">
            <section className="faq-hero container p-4 p-lg-5 rounded-5">
              <h1>
                {selectedLanguage.id === 1 ? "About Us" : "À propos de nous"}
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item cursorpointer" onClick={home}>
                    <a>{selectedLanguage.id === 1 ? "Home" : "Accueil"}</a>
                  </li>
                  <li className="breadcrumb-item active">
                    {selectedLanguage.id === 1
                      ? "About Us"
                      : "À propos de nous"}
                  </li>
                </ol>
              </nav>
            </section>
          </div>
          {aboutuslist.about_us?.length > 0 && (
            <section>
              <div className="bg-white container px-3 py-lg-5 my-lg-5">
                <div className="row align-items-center d-flex justify-content-between">
                  <div className="col-lg-6 col-xl-7 aboutsec">
                    <p className="small text-danger fw-bold mb-2">
                      {selectedLanguage.id === 1
                        ? "ABOUT US"
                        : "À PROPOS DE NOUS"}
                    </p>
                    <h2 className="fw-bold">
                      {aboutus ? aboutus.about_heading : ""}
                    </h2>
                    <p
                      className="text-muted mt-3"
                      dangerouslySetInnerHTML={{
                        __html: aboutus ? aboutus.about_description : "",
                      }}
                    ></p>

                    <div className="accordion" id="visionValueAccordion">
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="headingVision">
                          <button
                            className="accordion-button ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseVision"
                            aria-expanded="true"
                            aria-controls="collapseVision"
                          >
                            <span className="arrow-symbol"></span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: aboutusvision
                                  ? aboutusvision.aboutus_title_heading
                                  : "",
                              }}
                            ></span>
                          </button>
                        </h2>
                        <div
                          id="collapseVision"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingVision"
                          data-bs-parent="#visionValueAccordion"
                        >
                          <div
                            className="accordion-body ps-0 text-muted pt-3"
                            dangerouslySetInnerHTML={{
                              __html: aboutusvision
                                ? aboutusvision.aboutus_title_description
                                : "",
                            }}
                          ></div>
                        </div>
                      </div>

                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="headingValue">
                          <button
                            className="accordion-button collapsed ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseValue"
                            aria-expanded="false"
                            aria-controls="collapseValue"
                          >
                            <span className="arrow-symbol"></span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: aaboutusValue
                                  ? aaboutusValue.aboutus_title_heading
                                  : "",
                              }}
                            ></span>
                          </button>
                        </h2>
                        <div
                          id="collapseValue"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingValue"
                          data-bs-parent="#visionValueAccordion"
                        >
                          <div
                            className="accordion-body ps-0 text-muted pt-3"
                            dangerouslySetInnerHTML={{
                              __html: aaboutusValue
                                ? aaboutusValue.aboutus_title_description
                                : "",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="image-stack col-6 mt-5 ms-lg-0 mb-5 mb-lg-0">
                    <img src={group} className="doodle-left" alt="doodle" />
                    <img src={group1} className="doodle-right" alt="doodle" />
                    <img
                      src={city1}
                      className="stack-img img-back"
                      alt="city background"
                    />
                    <img
                      src={city2}
                      className="stack-img img-front"
                      alt="city foreground"
                    />
                  </div>
                </div>
              </div>
            </section>
          )}
          {aboutuslist.founder?.length > 0 && (
            <section className="pt-5 pb-5 founderwrap">
              <div className="container px-3">
                <div
                  className="row align-items-center gy-4"
                  ref={parentRef}
                  style={{ position: "relative" }}
                >
                  <div className="col-lg-5 text-center heig">
                    <div
                      className="founderleft"
                      ref={imageRef}
                      style={{
                        width: "100%",
                      }}
                    >
                      <div className="founder-wrap">
                        <div className="founder"></div>
                        <img
                          src={Founder}
                          alt="founder"
                          className="founder-photo"
                        />

                        <div className="founder-badge">
                          <img
                            src={icon}
                            alt="Icon"
                            className="img-fluid" /* style={{ maxWidth: "60%" }} */
                          />
                          <h4
                            className="canadian mt-2"
                            style={{ color: "red" }}
                          >
                            Canadian
                          </h4>
                          <h4 className="canadian" style={{ color: "red" }}>
                            & Chadian
                          </h4>
                        </div>
                        <div className="founder-years">
                          20+{" "}
                          <small className="d-block">
                            {selectedLanguage.id === 1
                              ? "Years of International  Experience"
                              : "Années d’expérience internationale"}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-lg-7 px-3 founderprofile"
                    ref={contentRef}
                  >
                    <p className="small text-danger fw-bold mb-2">
                      {selectedLanguage.id === 1
                        ? "FOUNDER PROFILE"
                        : "PROFIL DU FONDATEUR"}
                    </p>
                    <h2
                      className="foundername fw-bold"
                      dangerouslySetInnerHTML={{
                        __html: founder ? founder.founder_title : "",
                      }}
                    ></h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: founder?.founder_description?.replace(
                          /\n/g,
                          "<br/>",
                        ),
                      }}
                    ></p>

                    <div className="row stats mt-4 text-center successitems">
                      {Array.isArray(foundermetrics) &&
                      foundermetrics.length > 0
                        ? foundermetrics.map((item, index) => {
                            let displayValue = item.metrics_value;
                            if (displayValue == 2) {
                              displayValue = `${displayValue}X`;
                            } else if (displayValue == 50) {
                              displayValue = `${displayValue}K`;
                            } else if (displayValue == 93) {
                              displayValue = `${displayValue}%`;
                            }

                            return (
                              <div className="col-4 " key={index}>
                                <h1 className="text-danger fw-bold">
                                  {displayValue}
                                </h1>
                                <p className="small text-muted mb-0">
                                  {item.metrics}
                                </p>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {aboutuslist.our_story?.length > 0 && (
            <section className="story-area">
              <div className="container px-3 text-center">
                <div className="ourstory-box">
                  <p className="small text-danger fw-bold mb-2 missiontitle">
                    {ourstory ? ourstory.story_heading : ""}
                  </p>
                  <h2
                    className="storyhead fw-bold"
                    dangerouslySetInnerHTML={{
                      __html: ourstory ? ourstory.story_title : "",
                    }}
                  ></h2>
                  <p
                    className="storytext mt-lg-3"
                    dangerouslySetInnerHTML={{
                      __html: ourstory ? ourstory.story_description : "",
                    }}
                  ></p>

                  <div className="row g-4 mb-4 mt-md-4 storywrap">
                    {Array.isArray(ourstorysection) &&
                    ourstorysection.length > 0
                      ? ourstorysection.map((item, index) => (
                          <div className="col-md-4" key={index}>
                            <div className="story-card shadow-sm">
                              <h6
                                className="fw-bold"
                                dangerouslySetInnerHTML={{
                                  __html: item.heading,
                                }}
                              ></h6>
                              <p
                                className="text-muted mb-0"
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              ></p>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </section>
          )}
          {aboutuslist.our_mission?.length > 0 && (
            <section className="text-white ourmission">
              <div className="container px-3">
                <div className="heading">
                  <h5 className="missiontitle">
                    {ourmission ? ourmission.mission_heading : ""}
                  </h5>
                  <h2
                    className="missionhead fw-bold"
                    dangerouslySetInnerHTML={{
                      __html: ourmission ? ourmission.mission_title : "",
                    }}
                  ></h2>
                  <p
                    className="missiontext"
                    dangerouslySetInnerHTML={{
                      __html: ourmission ? ourmission.mission_description : "",
                    }}
                  ></p>
                </div>

                <div className="missionimgwrap">
                  <div className="col-lg-4 d-flex">
                    <img
                      src={mission}
                      alt="Mission Image"
                      className="image fluid mission-img"
                    />
                  </div>

                  <div className="col-lg-8">
                    <div className="row g-4 missionitems">
                      {Array.isArray(ourmissionsection) &&
                      ourmissionsection.length > 0
                        ? ourmissionsection.map((item, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="mission-item">
                                <h4 className="missionnumber text-danger">
                                  0{index + 1}
                                </h4>
                                <h6
                                  className="fw-bold"
                                  dangerouslySetInnerHTML={{
                                    __html: item.heading,
                                  }}
                                ></h6>
                                <p
                                  className="small text"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                ></p>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default AboutUs;
